import Request from '../../../../src/core/gd/data/request'
import RequestApp3 from "../data/request-app3";
import {compactGqlQuery} from "../utils/gql";


export default class ApiCRM {

    // accounts
    newAccount(params: any) {
        return new Request(this, 'POST', 'crm/accounts', params);
    }

    getAccounts() {
        return new Request(this, 'GET', 'crm/accounts');
    }

    updateAccount(id: ID, params: any) {
        return new Request(this, 'PUT', 'crm/account/{0}'.f(id), params);
    }

    getAccount(id: ID) {
        return new Request(this, 'GET ', 'crm/account/{0}'.f(id));
    }

    static getAccount2(id: ID) {
        return new Request(this, 'GET ', 'crm/account/{0}'.f(id));
    }

    deleteAccount(id: ID) {
        return new Request(this, 'DELETE', 'crm/account/{0}'.f(id));
    }

    // contacts
    newContact(params: any) {
        return new Request(this, 'POST', 'crm/contacts', params);
    }

    getContacts() {
        return new Request(this, 'GET', 'crm/contacts');
    }

    updateContact(id: ID, params: any) {
        return new Request(this, 'PUT', 'crm/contact/{0}'.f(id), params);
    }

    getContact(id: ID) {
        return new Request(this, 'GET ', 'crm/contact/{0}'.f(id));
    }

    static getContact2(id: ID) {
        return new Request(this, 'GET ', 'crm/contact/{0}'.f(id));
    }

    static getContactV3(id: ID) {

        // The task fields CrmContact_Tasks needs. The query has to name every one of them - the
        // contact's tasks go straight into Resources/Task, and the list then works off that
        // collection alone (CrmContact_TasksListManager.getTasks()), so a field left out here is
        // simply not there when a column, a filter or the grouping asks for it.
        //
        // GOTCHA: an opt-in group of the REST task API (taskUsers, timeReports, description,
        // predecessors/successors, expenses - see ApiSelectFields) is NOT included. Those need a
        // sub-selection of their own and no column of this list reads them yet.
        const CRM_CONTACT_TASK_FIELDS = `
            id shortId title systemType
        
            companyId projectId sortPosition parentTaskId
            taskTypeId taskStatusId systemStatus priority
        
            createdByUserId createdOnBehalfByUserId
            assignedToUserId
            actionRequiredUserId actionRequiredSinceDate
        
            scheduleStatus scheduleDate
            deadline startDate endDate
            momentClosed
        
            estimate progress storyPoints
        
            customFieldsData
            crmAccountId crmContactIds
        `

        // There are errors when these fields are requested.
        //     momentCreated latestActivityMoment
        //     messagesTotal attachmentsTotal
        //     tags

        // GOTCHA - customFieldsData has to be selected here. Without it the contact loads with
        // no custom field values at all: they render empty after a reload, and the next edit
        // then builds a fresh map from {} (CustomFieldsProxy creates it) which save() PUTs as
        // the whole column - erasing every other custom field the contact had.
        //
        // No comments inside the query itself: compactGqlQuery collapses it onto one line, so a
        // # comment would swallow the rest of it.
        const query = `query ($id: ID!) {
            crmContact(id: $id) {
                id 
                firstName 
                lastName 
                email 
                phone 
                contactType
                crmAccountId
                contactOwnerUserId
                notes
                customFieldsData
                momentCreated
                invitation {
                    id 
                    email 
                    invitationKey 
                    momentCreated 
                }
                tasks { ${CRM_CONTACT_TASK_FIELDS} }
                history {
                    id
                    userId
                    eventType
                    params
                    momentCreated
                }
                attachments {
                    id
                    fileId
                    name
                    size
                    mimeType
                    fileType
                    isFlagged
                    preview
                    storageProvider
                    userId
                    momentCreated
                }
                metadata
            }
        }`

        return RequestApp3(this, 'POST', 'graphql', {
            query       : compactGqlQuery(query),
            variables   : {
                id: id
            },
        });
    }

    deleteContact(id: ID) {
        return new Request(this, 'DELETE', 'crm/contact/{0}'.f(id));
    }

    static deleteContact2(id: ID) {
        return new Request(this, 'DELETE', 'crm/contact/{0}'.f(id));
    }

    inviteContact(id: ID) {
        return new Request(this, 'POST', 'crm/contact/{0}/invite'.f(id));
    }

    // Logs one activity into the contact's history - eventType is a CRMContactActivity of the
    // 1541-1543 range (note / call / email), params is the client's own object. The response is
    // the created history event, the same shape getContactV3 returns in `history`.
    static newContactActivity(id: ID, eventType: number, params: any) {
        return new Request(this, 'POST', 'crm/contact/{0}/activities'.f(id), {
            eventType   : eventType,
            params      : params
        });
    }

    // Replaces the params of a logged activity - eventId is the history event id. Author or
    // company admin only.
    static updateContactActivity(eventId: ID, params: any) {
        return new Request(this, 'PUT', 'crm/contact/activity/{0}'.f(eventId), {
            params: params
        })
    }

    static deleteContactActivity(eventId: ID) {
        return new Request(this, 'DELETE', 'crm/contact/activity/{0}'.f(eventId));
    }

    createCustomer(payload: any) {
        return new Request(this, 'POST', 'new/customer', payload);
    }

    static deleteAllCompanyContacts() {
        return new Request(this, 'DELETE', 'crm/contacts/company/delete');
    }
    static deleteAllCompanyAccounts() {
        return new Request(this, 'DELETE', 'crm/accounts/company/delete');
    }
}
